const overrides = (palette, typography) => ({})

export default overrides
